import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

const setCookieState = (name: string, value: boolean) => Cookies.set(name, String(value), { expires: 365 });

export const useCookieState = () => {
  const [didUserConsent, setDidUserConsent] = useState(false);
  const [didUserRespond, setDidUserRespond] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    const cookieExists = Cookies.get('cookieConsent');
    setDidUserRespond(cookieExists ? true : false);
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (didUserRespond && isHydrated) {
      setCookieState(
        'cookieConsent',
        Cookies.get('cookieConsent') ? Cookies.get('cookieConsent') === 'true' : didUserConsent,
      );
    }
  }, [didUserRespond, didUserConsent, isHydrated]);

  return { didUserRespond, setDidUserRespond, setDidUserConsent, isHydrated };
};
